import { Modal } from "antd";
import React from "react";
import { LargeButton } from "../Button/Button";

type Step6CongratsModalProps = {
  open?: boolean;
  onClose?: () => void;
  isUk?: boolean;
};

export const Step6CongratsModal = ({
  open,
  onClose,
  isUk,
}: Step6CongratsModalProps) => {
  return (
    <Modal
      className="tailwind-modal"
      open={open}
      closable
      onCancel={onClose}
      footer={null}
    >
      <div className="tailwind">
        <div className="mb-[10px]">
          <h5 className="text-[#24052B]">Congratulations!</h5>
        </div>

        <p>
          You are now on the waiting list for the Portfolio Builder. You can
          read more about it&nbsp;
          <a
            href={
              isUk
                ? "https://www.bitcoinwealthbuilder.io/bwb"
                : "http://simondixon.com/bwb"
            }
            target="_blank"
            className="underline font-semibold"
          >
            here
          </a>
          &nbsp;and we will send you an email when registration is open
        </p>

        <LargeButton className="block mt-[40px]" onClick={onClose}>
          OK, I understand
        </LargeButton>
      </div>
    </Modal>
  );
};
